import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b9e017e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tipText"
}

import CommonStore from "@/store/modules/common";
import { requestTimeFormat, timeFormat } from "@/utils/utilsHandle";
import _ from "lodash";

import { getCurrentInstance, reactive, onMounted, computed, nextTick } from "vue";
// 全局实例

export default /*#__PURE__*/_defineComponent({
  props: {
  isEdit: {
    type: Boolean,
    default: false,
  },
  formInited: {
    type: Boolean,
    default: false,
  },
  entity: {
    type: String,
    default: "",
  },
  templateCode: {
    type: Object,
    default: null,
  },
},
  setup(__props, { expose }) {

const props = __props

const { proxy } = getCurrentInstance() as any;
const MAS_DATE_PREFIX = "MAS_DATE_PREFIX_";

const getDynamicData = computed(() => {
  return proxy.$stores.retrieveStore(CommonStore).getDynamicMapInfo;
});

const getDynamicDefaultData = computed(() => {
  return proxy.$stores.retrieveStore(CommonStore).getDynamicMapDefaultData;
});

const form: any = reactive({
  tipText: "",
  filters: {
    formValue: {},
    direction: "row",
    itemWidth: 260,
    labelWidth: 120,
    items: [],
  },
});
const state = reactive({
  updateKey: 0,
});

const loadDynamicDefinition = () => {
  let obj: any = {};
  let filterFlag = props.templateCode && props.templateCode !== null ? true : false;
  if (!getDynamicData.value[props.entity]?.properties) return false;
  if (getDynamicData.value && getDynamicData.value[props.entity].properties?.length) {
    getDynamicData.value[props.entity].properties
      ?.filter(
        (x: any) =>
          (filterFlag ? x.templateCode === props.templateCode : !x.templateCode) &&
          !x.disabled
      )
      .forEach((x: any) => {
        if (!x.disabled) {
          obj = {
            label: x.displayName,
            name: x.name,
            type: setInputType(x),
            ruleType: x.displayType,
            placeholder: x.displayType === "multi_line_text" ? "" : x.hintMsg,
            errorMsg: "",
            rows: 5,
            rules: x.validations,
            requiredErrorTip: "",
            require: setRequired(x),
            multiple: x.displayType === "multi_dropdown" ? true : false,
            options: x.selections?.length ? x.selections : [],
          };
          form.filters.items.push(obj);
          form.filters.formValue[x.name] = getDynamicDefaultData.value[x.name]
            ? getDynamicDefaultData.value[x.name]
            : "";
          if (x.displayType === "multi_dropdown" && form.filters.formValue[x.name]) {
            if (
              !_.isArray(form.filters.formValue[x.name]) &&
              form.filters.formValue[x.name].split(",").length
            ) {
              form.filters.formValue[x.name] = form.filters.formValue[x.name].split(",");
            }
          }

          console.log(form.filters.formValue[x.name], "www");
          switch (x.displayType) {
            case "date":
              form.filters.formValue[x.name] = getDynamicDefaultData.value[x.name]
                ? timeFormat(getDynamicDefaultData.value[x.name], 1)
                : "";
              form.filters.formValue[MAS_DATE_PREFIX + x.name] = getDynamicDefaultData
                .value[x.name]
                ? String(getDynamicDefaultData.value[x.name])
                : "";
              break;
          }
        }
      });

    state.updateKey = new Date().getTime();
  }
};

const setRequired = (item: any) => {
  if (item.validations && item.validations?.length) {
    let isHaveRequired = item.validations.filter(
      (x: any) => x.type === "REQUIRED" || x.type === "REGEXP"
    );
    if (isHaveRequired.length) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

const setInputType = (item: any) => {
  switch (item.displayType) {
    case "single_dropdown":
    case "multi_dropdown":
      return "select";
    case "radio":
    case "multi_select":
      return "radioButton";
    case "single_line_text":
    case "single_line_number":
      return "input";
    case "multi_line_text":
      return "textarea";
    case "datetime":
      return "dateTimePicker";
    default:
      break;
  }
};
// 修改updateKey使表单重新渲染
const onFiltersChange = (newFormValue: any) => {
  form.filters.formValue = newFormValue;
  state.updateKey = new Date().getTime();
};
const setDynamicMapText = () => {
  form.tipText = "";
  form.filters.items.forEach((x: any) => {
    if (x.require) {
      if (x.rules?.length) {
        x.rules.forEach((y: any) => {
          if (y.type === "REQUIRED" || y.type === "REGEXP") {
            if (
              form.filters.formValue[x.name] === "" ||
              form.filters.formValue[x.name] === undefined ||
              !new RegExp(y.rule).test(form.filters.formValue[x.name])
            ) {
              form.tipText = y.errorMsg;
              throw new Error(form.tipText);
            }
          }
        });
      }
    }
  });
  Object.keys(form.filters.formValue).forEach((key: string) => {
    if (key.indexOf(MAS_DATE_PREFIX) != -1) {
      form.filters.formValue[key] =
        form.filters.formValue[key.replace(MAS_DATE_PREFIX, "")];
      form.filters.formValue[key.replace(MAS_DATE_PREFIX, "")] = requestTimeFormat(
        form.filters.formValue[key]
      );
    }
  });
  return true;
};

expose({
  form,
  setDynamicMapText,
});

onMounted(() => {
  setTimeout(() => {
    loadDynamicDefinition();
  }, 800);
});

return (_ctx: any,_cache: any) => {
  const _component_base_form = _resolveComponent("base-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_form, {
      ref: "masForm",
      formConfig: _unref(form).filters,
      updateKey: _unref(state).updateKey,
      onChange: onFiltersChange,
      footer: false
    }, null, 8, ["formConfig", "updateKey"]),
    (_unref(form).tipText)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(form).tipText), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})